import { useEffect, type RefObject } from "react";

/** Include a control's portalled options when deciding whether an interaction is outside. */
export function useOutsideDismiss(ref: RefObject<HTMLElement | null>, active: boolean, dismiss: () => void, portalOwner?: string) {
  useEffect(() => {
    if (!active) return;
    const outside = (event: Event) => {
      const target = event.target;
      if (!(target instanceof Element) || ref.current?.contains(target)) return;
      if (portalOwner && target.closest("[data-dropdown-owner]")?.getAttribute("data-dropdown-owner") === portalOwner) return;
      dismiss();
    };
    document.addEventListener("pointerdown", outside, true);
    document.addEventListener("focusin", outside, true);
    return () => {
      document.removeEventListener("pointerdown", outside, true);
      document.removeEventListener("focusin", outside, true);
    };
  }, [ref, active, dismiss, portalOwner]);
}
